import { GainLossRoles } from "./store/rolesList"
import RestEndPoint from "../../common/RestEndPoint"
import {
    JURISDICTION_PALINS_NORTH,
    JURISDICTION_PALINS_SOUTH
} from "../../constants/gainLoss"

const {
    GAINLOSS_ADMIN,
    GAINLOSS_NORTHDATAENTRY,
    GAINLOSS_NORTHDISTRICTSIGNOFF,
    GAINLOSS_SOUTHDATAENTRY,
    GAINLOSS_SOUTHDISTRICTSIGNOFF
} = GainLossRoles

// north roles who can view action buttons
const northActionBtnRoles = [
    GAINLOSS_ADMIN,
    GAINLOSS_NORTHDATAENTRY,
    GAINLOSS_NORTHDISTRICTSIGNOFF
]
// south roles who can view action buttons
const soutActionBtnRoles = [
    GAINLOSS_ADMIN,
    GAINLOSS_SOUTHDATAENTRY,
    GAINLOSS_SOUTHDISTRICTSIGNOFF
]

export const canUserViewIntegrationBtns = (selectedJurisdiction) => {
    let canUserView = false

    if (selectedJurisdiction === JURISDICTION_PALINS_NORTH) {
        canUserView = hasAccess(northActionBtnRoles)
    } else if (selectedJurisdiction === JURISDICTION_PALINS_SOUTH) {
        canUserView = hasAccess(soutActionBtnRoles)
    }

    return canUserView
}

const hasAccess = (roles) => {
    let match = false
    for (let [key, value] of Object.entries(roles)) {
        if (RestEndPoint.checkCurrentUserHasRole(value)) {
            match = true
            break
        }
    }
    return match
}